import { useLayoutEffect } from "react";
import { Outlet, ScrollRestoration } from "react-router";
import { styled } from "@pigment-css/react";
import { baseTheme } from "@acto/web-common/theme";
import { SuccessModalProvider } from "./components/primitives/FullScreenSuccessModal";
import { ToastProvider } from "./components/primitives/Toast";

const LayoutWrapper = styled("div")(({ theme }) => ({
  minWidth: "100%",
  minHeight: "100vh",
  backgroundColor: theme.fieldSalesTwo.colors.background,
  color: theme.fieldSalesTwo.colors.neutral[900],
  fontFamily: theme.fieldSalesTwo.font.family,
  fontSize: theme.fieldSalesTwo.font.size.base,
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
}));

export function Layout() {
  useLayoutEffect(() => {
    const root = document.documentElement;
    root.style.setProperty("--app-bg", baseTheme.fieldSalesTwo.colors.background);
    root.style.setProperty("--app-scrollbar-gutter", "stable");

    return () => {
      root.style.removeProperty("--app-bg");
      root.style.removeProperty("--app-scrollbar-gutter");
    };
  }, []);

  return (
    <SuccessModalProvider>
      <ToastProvider>
        <LayoutWrapper>
          <ScrollRestoration />
          <Outlet />
        </LayoutWrapper>
      </ToastProvider>
    </SuccessModalProvider>
  );
}
